import React from 'react';
import ReactDOM from 'react-dom/client';

import { createStore } from 'polotno/model/store';
import { unstable_setAnimationsEnabled } from 'polotno/config';
// import { Auth0Provider } from '@auth0/auth0-react'; // Auth0 disabled
import { createProject, ProjectContext } from './project';
import { SubscriptionProvider } from './subscription-context';

import './index.css';
import App from './App';
import './logger';
import { ErrorBoundary } from 'react-error-boundary';

if (window.location.host !== 'studio.polotno.com') {
  console.log(
    `%cWelcome to Polotno Studio! Thanks for your interest in the project!
This repository has many customizations from the default version Polotno SDK.
I don't recommend to use it as starting point. 
Instead, you can start from any official demos, e.g.: https://polotno.com/docs/demo-full-editor 
or direct sandbox: https://codesandbox.io/s/github/polotno-project/polotno-site/tree/source/examples/polotno-demo?from-embed.
But feel free to use this repository as a reference for your own project and to learn how to use Polotno SDK.`,
    'background: rgba(54, 213, 67, 1); color: white; padding: 5px;'
  );
}

unstable_setAnimationsEnabled(false);

const store = createStore({ key: 'w7sPX8mEz_VjM9uPD4gH' /*'nFA5H9elEytDyPyvKL7T' */});
window.store = store;
store.addPage();
store.addPage();
const project = createProject({ store });
window.project = project;

const root = ReactDOM.createRoot(document.getElementById('root'));

// Auth0 configuration - disabled
// const AUTH_DOMAIN = 'polotno-studio.eu.auth0.com';
// const PRODUCTION_ID = process.env.REACT_APP_AUTH0_ID;
// const LOCAL_ID = process.env.REACT_APP_AUTH0_ID;
// const isLocalhost =
//   typeof window !== undefined && window.location.href.indexOf('localhost') >= 0;
// const ID = isLocalhost ? LOCAL_ID : PRODUCTION_ID;
// const REDIRECT = isLocalhost
//   ? 'http://localhost:3000'
//   : 'https://studio.polotno.com';

function Fallback({ error, resetErrorBoundary }) {
  // Call resetErrorBoundary() to reset the error boundary and retry the render.

  return (
    <div style={{ width: '100vw', height: '100vh' }}>
      <div style={{ textAlign: 'center', paddingTop: '400px' }}>
        <p>Something went wrong in the app.</p>
        <p>Try to reload the page.</p>
        <p>If it does not work, clear cache and reload.</p>
        <button
          onClick={async () => {
            await project.clear();
            window.location.reload();
          }}
        >
          Clear cache and reload
        </button>
      </div>
    </div>
  );
}

root.render(
  <ErrorBoundary
    FallbackComponent={Fallback}
    onReset={(details) => {
      // Reset the state of your app so the error doesn't happen again
    }}
    onError={(e) => {
      if (window.Sentry) {
        window.Sentry.captureException(e);
      }
    }}
  >
    <ProjectContext.Provider value={project}>
         <SubscriptionProvider>
        <App store={store} />
        </SubscriptionProvider>
      </ProjectContext.Provider>
  </ErrorBoundary>
);
